import { mergeToNewObject } from 'src/libs/qb-brand-web-components'

import { MAIN_PROFILE_ACTION, QUEST_ACTION } from '../../../constants/actions'
import {
  extractQuestRewardError,
  formatQuests,
  QUEST_FILTER_TYPE
} from '../../../util/quest.helpers'

export const questProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case MAIN_PROFILE_ACTION.ON_LOAD_MAIN_DATA_SUCCESS:
      const { quests } = payload
      return mergeToNewObject(state, {
        all: quests,
        ...formatQuests(quests)
      })

    case QUEST_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, { [payload.property]: payload.value })

    case QUEST_ACTION.UPDATE_QUEST:
      return mergeToNewObject(state, {
        loading: true,
        error: {}
      })

    case QUEST_ACTION.UPDATE_QUEST_SUCCESS:
      const { id } = payload
      const all = state.all.map((quest) => (quest.id === id ? payload : quest))
      return mergeToNewObject(state, {
        filterBy: QUEST_FILTER_TYPE.COMPLETED,
        loading: false,
        all,
        ...formatQuests(all)
      })

    case QUEST_ACTION.UPDATE_QUEST_FAILED:
      return mergeToNewObject(state, {
        loading: false,
        error: { questReward: extractQuestRewardError(payload) }
      })

    default:
      return state
  }
}

const INITIAL_STATE = {
  filterBy: QUEST_FILTER_TYPE.ACTIVE,
  all: [],
  active: [],
  completed: [],
  loading: false,
  error: {}
}

export const QUEST_PROFILE_DISPATCH = {
  FILTER_BY: 'filterBy',
  ERROR: 'error'
}
